<template>
  <div class="home">
    <m-header
      :showPop="showPop"
      @closePop="showPop = false"
      @openPop="showPop = true"
      ref="mheader"
    />
    <div class="banner-top"></div>
    <div class="banner-bottom">
      <div class="content">
        <div class="main">
          <div class="main-head">
            <div class="title">实践考核报名</div>
          </div>
          <div class="main-box">
            <i class="pic1"></i>
            <div
              class="appy"
              :class="{'appay-change':((signStatus != 1) || (signInfo == true))}"
              @click="toSignUp"
            >去报名</div>
            <p v-if="signStatus == 1">开始时间：{{beginTime}}</p>
            <p v-if="signStatus == 1">截止时间：{{endTime}}</p>
            <p v-if="(signStatus != 1) || (signInfo == true)">当前不在报名时间</p>
          </div>
        </div>
        <div class="main">
          <div class="main-head">
            <div class="title">实践培训报名</div>
          </div>
          <div class="main-box">
            <i class="pic3"></i>
            <div class="submit" :class="{'submit-change': trainStatus !== 1}" @click="toTrain">去报名</div>
            <p v-if="trainStatus == 1">开始时间：{{trainStartTime}}</p>
            <p v-if="trainStatus == 1">截止时间：{{trainEndTime}}</p>
            <p v-else>尚未报名实践考核</p>
          </div>
        </div>
        <div class="main">
          <div class="main-head">
            <div class="title">毕业论文评审</div>
          </div>
          <div class="main-box">
            <i class="pic2"></i>
            <div
              class="submit"
              :class="{'submit-change': submitStatus !== 1}"
              @click="submitPaper"
            >提交评审</div>
            <p v-if="submitStatus == 1">开始时间：{{submitStartTime}}</p>
            <p v-if="submitStatus == 1">截止时间：{{submitEndTime}}</p>
            <p v-else>当前不在开放时间</p>
          </div>
        </div>
        <div class="main">
          <div class="main-head">
            <div class="title">学位论文评审</div>
          </div>
          <div class="main-box">
            <i class="pic2"></i>
            <div
              class="submit"
              :class="{'submit-change': degreeSubmitStatus !== 1}"
              @click="degreeSubmitPaper"
            >提交评审</div>
            <p v-if="degreeSubmitStatus == 1">开始时间：{{degreeSubmitStartTime}}</p>
            <p v-if="degreeSubmitStatus == 1">截止时间：{{degreeSubmitEndTime}}</p>
            <p v-else>当前不在开放时间</p>
          </div>
        </div>
        <div class="notice">
          <div class="notice-head">
            <div class="title">通知公告</div>
            <router-link to="/notice" class="more" v-if="originList.length > 5">
              <span>更多</span>
              <i></i>
            </router-link>
          </div>
          <div class="notice-content" v-for="item in list" :key="item.id">
            <router-link
              class="text"
              tag="a"
              target="_blank"
              :to="{name: 'detail',query:{forumId: item.forumId}}"
            >{{item.forumTitle}}</router-link>
            <!-- <span class="text">{{item.forumTitle}}</span> -->
            <span class="time">{{item.publishDate}}</span>
          </div>
        </div>
      </div>
    </div>
    <m-footer />
  </div>
</template>

<script>
import MHeader from "../../components/Header";
import MFooter from "../../components/Footer";
import { getToken } from "@/utils/auth";
export default {
  name: "home",
  components: {
    MHeader,
    MFooter,
  },
  data() {
    return {
      list: [], //通知公告列表（最多5条）
      originList: [], //通知公告原数组
      signStatus: 0, //报名状态
      signInfo: false, //是否在报名时间内
      beginTime: "", //开始时间
      endTime: "", //结束时间
      showPop: false, //登录注册弹窗是否展示
      submitStatus: 0, // 论文上传状态 0 未开始 1 进行中 2 已结束
      submitStartTime: "2021-11-20 22:00:00", //论文上传开始时间
      submitEndTime: "2021-11-20 22:00:00", //论文上传结束时间
      degreeSubmitStatus: 0, // 论文上传状态 0 未开始 1 进行中 2 已结束
      degreeSubmitStartTime: "2021-11-20 22:00:00", //论文上传开始时间
      degreeSubmitEndTime: "2021-11-20 22:00:00", //论文上传结束时间
      paperStatus: 0, //论文校验状态 0 通过 1 未查到当前批次报名记录，不支持提交论文 2 论文已提交，不可重复提交
      degreePaperStatus: 0, //学位论文校验状态 0 通过 1 未查到当前批次报名记录，不支持提交论文 2 论文已提交，不可重复提交
      trainStatus: 0, //培训报名状态
      trainStartTime: "", //培训开始时间
      trainEndTime: "", //培训结束时间
    };
  },
  watch: {
    $route(to, from) {
      if (to.query != from.query) {
        let that = this;
        this.$refs.mheader.checkPassword(function () {
          that.$router.push({ path: "/record?id=3" }).catch(() => {});
        });
      }
    },
  },
  mounted() {
    let that = this;
    this.$refs.mheader.checkPassword(function () {
      that.$router.push({ path: "/record?id=3" }).catch(() => {});
    });
    this.getIndex();
    this.checkPaper();
    this.checkDegreePaper();
  },
  methods: {
    getIndex() {
      this.$request.getIndex().then((res) => {
        // console.log(res)
        if (res.retcode === "0") {
          if (res.data.signInfo !== null) {
            this.signStatus = res.data.signInfo.signStatus;
            this.beginTime = res.data.signInfo.signStartTime;
            this.endTime = res.data.signInfo.signEndTime;
          } else {
            this.signInfo = true;
          }
          if (
            res.data.noticeList === null ||
            res.data.noticeList.length === 0
          ) {
            this.list = [];
            this.originList = [];
          } else {
            this.list = res.data.noticeList.slice(0, 5);
            this.originList = res.data.noticeList;
          }
          if (res.data.submitInfo !== null) {
            //论文上传信息
            this.submitStatus = res.data.submitInfo.submitStatus;
            this.submitStartTime = res.data.submitInfo.submitStartTime;
            this.submitEndTime = res.data.submitInfo.submitEndTime;
          }
          if (res.data.degreeSubmitInfo !== null) {
            //学位论文上传信息
            this.degreeSubmitStatus = res.data.degreeSubmitInfo.submitStatus;
            this.degreeSubmitStartTime = res.data.degreeSubmitInfo.submitStartTime;
            this.degreeSubmitEndTime = res.data.degreeSubmitInfo.submitEndTime;
          }
          if (res.data.trainInfo !== null) {
            //培训报名信息
            this.trainStatus = res.data.trainInfo.trainStatus;
            this.trainStartTime = res.data.trainInfo.trainStartTime;
            this.trainEndTime = res.data.trainInfo.trainEndTime;
          }
        }
      });
    },
    //校验论文上传
    checkPaper() {
      this.$request
        .checkPaperStatus({})
        .then((res) => {
          if (res.retcode === "0") {
            this.paperStatus = res.data;
          }
        })
        .catch(() => {});
    },
    //校验学位论文上传
    checkDegreePaper() {
      this.$request
        .checkDegreePaperStatus({})
        .then((res) => {
          if (res.retcode === "0") {
            this.degreePaperStatus = res.data;
          }
        })
        .catch(() => {});
    },
    //去实践考核报名
    toSignUp() {
      if (!getToken()) {
        //未登录调取登录框
        document.body.scrollTop = 0;
        this.showPop = true;
      } else if (this.signStatus == 1) {
        //登录后且在时间内跳转报名页
        this.$router.push("/enroll");
      } else {
        //登录后不在时间内文案提示，按钮置灰
      }
    },
    //去实践培训报名
    toTrain() {
      if (!getToken()) {
        //未登录调取登录框
        document.body.scrollTop = 0;
        this.showPop = true;
      } else if (this.trainStatus == 1) {
        //登录后且在时间内跳转报名页
        this.$router.push("/train");
      } else {
        //登录后不在时间内文案提示，按钮置灰
      }
    },
    //提交论文
    submitPaper() {
      if (!getToken()) {
        //未登录调取登录框
        document.body.scrollTop = 0;
        this.showPop = true;
      } else if (this.submitStatus !== 1) {
        return false;
      } else if (this.paperStatus === 1) {
        this.$message.error("未查到当前批次报名记录，不支持提交论文");
      } else if (this.paperStatus === 2) {
        this.$message.error("论文已提交，不可重复提交");
      } else {
        this.$router.push("/paper");
      }
    },
    //提交学位论文
    degreeSubmitPaper() {
      if (!getToken()) {
        //未登录调取登录框
        document.body.scrollTop = 0;
        this.showPop = true;
      } else if (this.degreeSubmitStatus !== 1) {
        return false;
      } else if (this.degreePaperStatus === 1) {
        this.$message.error("未查到当前批次报名记录，不支持提交论文");
      } else if (this.degreePaperStatus === 2) {
        this.$message.error("论文已提交，不可重复提交");
      } else {
        this.$router.push("/degreePaper");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  background: #ffffff;
  .banner-top {
    height: 480px;
    // background: url('https://cdn-static-web.moycp.com/nfyk/image/banner.png') center no-repeat;
    background: url("../../assets/images/banner.png") center no-repeat;
    // background-size: 110% 480px;
    background-size: cover;
  }
  .banner-bottom {
    margin-top: 58px;
    height: 386px;
    background: url("https://cdn-static-web.moycp.com/nfyk/image/content.png")
      center no-repeat;
    background-size: 110% 386px;
    // background-size: cover;
    .content {
      margin: 0 auto;
      width: 1400px;
      display: flex;
      .main {
        margin-right: 12px;
        .main-head {
          width: 180px;
          height: 30px;
          border-bottom: 1px solid #ebebed;
          .title {
            width: 110px;
            height: 22px;
            font-size: 18px;
            font-weight: 600;
            color: #096cb8;
            position: relative;
            &:after {
              position: absolute;
              content: "";
              width: 100%;
              height: 4px;
              border-radius: 2px;
              bottom: -8px;
              left: 0;
              background: #096cb8;
            }
          }
        }
        .main-box {
          margin-top: 24px;
          width: 220px;
          height: 280px;
          background: rgba(9, 108, 184, 0.06);
          border-radius: 8px;
          text-align: center;
          .pic1 {
            // margin: 60px 110px 40px;
            margin: 60px 50px 40px;
            display: inline-block;
            // width: 58px;
            // height: 58px;
            width: 50px;
            height: 50px;
            background: url("https://cdn-static-web.moycp.com/nfyk/image/appy.png")
              center no-repeat;
            background-size: contain;
          }
          .pic2 {
            margin: 60px 50px 40px;
            display: inline-block;
            width: 50px;
            height: 50px;
            background: url("https://cdn-static-web.moycp.com/nfyk/image/submit.png")
              center no-repeat;
            background-size: contain;
          }
          .pic3 {
            margin: 60px 50px 40px;
            display: inline-block;
            width: 50px;
            height: 50px;
            background: url("../../assets/images/train.png") center no-repeat;
            background-size: contain;
          }
          .appy {
            margin: 0 auto 14px;
            width: 111px;
            height: 32px;
            line-height: 32px;
            background: #096cb8;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            cursor: pointer;
          }
          .appay-change {
            background: #cecece;
          }
          .submit {
            margin: 0 auto 14px;
            width: 111px;
            height: 32px;
            line-height: 32px;
            background: #096cb8;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            cursor: pointer;
          }
          .submit-change {
            background: #cecece;
          }
          p {
            margin-top: 5px;
            font-size: 12px;
            color: #999999;
          }
        }
      }
      .notice {
        margin-left: 34px;
        .notice-head {
          width: 482px;
          height: 30px;
          border-bottom: 1px solid #ebebed;
          display: flex;
          justify-content: space-between;
          .title {
            width: 76px;
            height: 22px;
            font-size: 18px;
            font-weight: 600;
            color: #096cb8;
            position: relative;
            &:after {
              position: absolute;
              content: "";
              width: 100%;
              height: 4px;
              border-radius: 2px;
              bottom: -8px;
              left: 0;
              background: #096cb8;
            }
          }
          .more {
            width: 50px;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            span {
              font-size: 12px;
              font-weight: 500;
              color: #8b8b8b;
            }
            i {
              display: inline-block;
              width: 10px;
              height: 10px;
              background: url("https://cdn-static-web.moycp.com/nfyk/image/add.png")
                center no-repeat;
              background-size: contain;
            }
          }
        }
        .notice-content {
          width: 482px;
          height: 59px;
          line-height: 64px;
          border-bottom: 1px dashed #cccccc;
          display: flex;
          justify-content: space-between;
          .text {
            display: inline-block;
            width: 380px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 16px;
            color: #333333;
          }
          .time {
            font-size: 16px;
            color: #8b8b8b;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue